import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "components/ui/Select";
import classNames from "components/ui/classNames";
import { useIntl } from "react-intl";

interface SelectFilterByYearProps {
  value: number | null;
  onChange: (value: number | null) => void;
  availableYears: number[];
  disabled?: boolean;
}

export default function SelectFilterByYear({ value, onChange, availableYears, disabled }: SelectFilterByYearProps) {
  const intl = useIntl();

  return (
    <Select
      value={value ? String(value) : "ALL"}
      disabled={disabled}
      onValueChange={(newValue) => {
        if (newValue === "ALL") {
          return onChange(null);
        }

        return onChange(parseInt(newValue, 10));
      }}
    >
      <SelectTrigger
        className={classNames(
          "font-aeonik",
          "w-full rounded-lg",
          "border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-800",
          "text-sm font-medium tracking-wide text-slate-600 dark:text-slate-300",
          "disabled:select-none",
          "hover:border-transparent hover:ring-4 hover:ring-slate-100 hover:ring-offset-1 hover:ring-offset-slate-300 dark:hover:ring-slate-700 dark:hover:ring-offset-slate-500",
          "focus-visible:border-transparent focus-visible:ring-4 focus-visible:ring-indigo-100 focus-visible:ring-offset-1 focus-visible:ring-offset-indigo-300 dark:focus-visible:ring-indigo-900 dark:focus-visible:ring-offset-indigo-500",
          "truncate",
        )}
      >
        <SelectValue
          placeholder={intl.formatMessage({
            defaultMessage: "Filtre o ano",
            id: "0HA0Sr",
          })}
        />
      </SelectTrigger>
      <SelectContent
        className="rounded-lg border border-slate-200 text-sm dark:border-slate-700 dark:bg-slate-800"
        side="top"
      >
        <SelectItem
          value="ALL"
          className={classNames({
            "text-red-500 dark:text-red-400": value !== null,
          })}
        >
          {value === null
            ? intl.formatMessage({
                defaultMessage: "Filtre o ano",
                id: "0HA0Sr",
              })
            : intl.formatMessage({
                defaultMessage: "Remover filtro",
                id: "J5Id85",
              })}
        </SelectItem>

        {availableYears.map((year) => (
          <SelectItem key={`selectBoxYear/${year}`} value={String(year)} className="w-full">
            {year}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
